import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-section-title',
    templateUrl: './section-title.component.html',
    styleUrls: ['./section-title.component.scss'],
    standalone: false
})
export class SectionTitleComponent implements OnInit {
  @Input() width: number;
  @Input() height: number;
  @Input() image: string;
  @Input() optionName: string;
  @Input() pageName: string;

  constructor(
  ) { }

  ngOnInit(): void {
  }

}
